var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginDayLengthIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M4.812 17a8 8 0 0 0 0 2.001L0 19v-2zm-.59-8.192 3.396 3.396a7.7 7.7 0 0 0-1.414 1.414l-3.396-3.396zM13 6v4.812a8 8 0 0 0-2 0V6zm6.778 2.808 1.414 1.414-3.396 3.396a7.7 7.7 0 0 0-1.415-1.414zM24 17v2l-4.812.001a8 8 0 0 0 0-2zm-12-5q2.5 0 4.25 1.75T18 18q0 .517-.075 1H6.075A6.6 6.6 0 0 1 6 18q0-2.5 1.75-4.25T12 12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F700",
  fillRule: "evenodd",
  d: "M12 14q1.65 0 2.825 1.175T16 18q0 .525-.119 1H8.12A4 4 0 0 1 8 18q0-1.65 1.175-2.825T12 14"
}))));
export default SvgPluginDayLengthIcon;